import { Radio } from "@fluentui/react-components";
import { Grid16Regular, Grid24Regular } from "@fluentui/react-icons";
import ContextualMenuV2, { ListItem } from "components/contextualMenu/ContextualMenuV2";
import { ThreadCategory, THREAD_CATEGORY_LABELS } from "models/inbox/inbox";
import "./CategorySelector.scss";

interface CategorySelectorProps {
  currentCategory?: ThreadCategory;
  onCategoryChange: (category: ThreadCategory) => void;
  mobile?: boolean;
  disabled?: boolean;
}

export default function CategorySelector({
  currentCategory = ThreadCategory.None,
  onCategoryChange,
  mobile = false,
  disabled = false
}: CategorySelectorProps) {
  const currentLabel = THREAD_CATEGORY_LABELS[currentCategory];

  // Create menu items with radio buttons for single selection
  const menuItems: ListItem[] = Object.entries(THREAD_CATEGORY_LABELS).map(([value, label]) => ({
    key: `category-${value}`,
    content: (
      <Radio
        label={label}
        checked={Number(value) === currentCategory}
        className="disable-click"
      />
    ),
    onClick: () => {
      if (!disabled) {
        onCategoryChange(Number(value) as ThreadCategory);
      }
    }
  }));

  // Mobile: Icon-only button
  if (mobile) {
    return (
      <div className="category-selector-mobile">
        <ContextualMenuV2
          menuItems={menuItems}
          buttonIcon={() => <Grid24Regular />}
          buttonText={currentCategory === ThreadCategory.None ? "" : currentLabel}
          buttonStyle="category-button-mobile"
          buttonAppearance="transparent"
          buttonDisabled={disabled}
        />
      </div>
    );
  }

  // Desktop: Labeled button with current category and icon
  return (
    <div className="category-selector-desktop">
      <ContextualMenuV2
        menuItems={menuItems}
        buttonText={`Kategori${currentCategory === ThreadCategory.None ? "" : ": " + currentLabel}`}
        buttonIcon={() => <Grid16Regular />}
        buttonStyle="category-button-desktop"
        buttonAppearance="subtle"
        buttonDisabled={disabled}
        showChevron={true}
      />
    </div>
  );
}
